import React from 'react';
export function DuplicateIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.129 6.892a2.982 2.982 0 00-2.12-.88h-1v-1a3 3 0 00-3-3l-10-.016a3.044 3.044 0 00-3 3L2 14.986a3 3 0 002.995 3h1v1a3 3 0 002.995 3l10 .015a3 3 0 003-3l.014-10a2.978 2.978 0 00-.875-2.109zM4.287 15.7A.993.993 0 014 14.988l.014-10a1 1 0 011-1l10 .015a1 1 0 011 1l-.014 10a1 1 0 01-1 1l-8-.012H5a1.001 1.001 0 01-.713-.29zm15.7 3.316a1 1 0 01-1 1L8.988 20a1 1 0 01-1-1v-1l7 .011H15a3 3 0 003-3l.01-7h1a1 1 0 011 1l-.023 10.005z"
  }));
}